// extracted by mini-css-extract-plugin
export default {"openNew":"WL5dI","genAiCard":"kewru","actionArea":"jflfN","description":"mKkGe","heading":"TJlJN"};